import { isLuxPlusSubscriptionInCart } from 'checkout/selectors/view/luxPlusSubscriptionItems'
import {
  getCanViewLuxPlusBenefits,
  getIsEnabledFlightsBundleLuxPlusPriceWithSubscriptionInCart,
  getIsEnabledFlightsLuxPlusPreview,
  getIsEnabledFlightsShowLuxPlusPriceToEveryone,
  getIsFlightsLuxPlusPricingEligibleSpoofedNonMember,
  getIsFreePreviewLuxPlusMember,
} from 'luxPlus/selectors/featureToggle'

interface FlightLuxPlusPricingOptions {
  enabled?: boolean
  isBundledFlow?: boolean
}

export function canRequestFlightLuxPlusPricing(state: App.State, options: FlightLuxPlusPricingOptions): boolean {
  const { enabled, isBundledFlow } = options
  if (!enabled) {
    return false
  }

  const subscriptionInCart =
    getIsEnabledFlightsBundleLuxPlusPriceWithSubscriptionInCart(state) &&
    isLuxPlusSubscriptionInCart(state)
  const isLuxPlusPricingShownToEveryone = getIsEnabledFlightsShowLuxPlusPriceToEveryone(state)

  const isPreviewMemberBlocked =
    !getIsEnabledFlightsLuxPlusPreview(state) &&
    getIsFreePreviewLuxPlusMember(state) &&
    !subscriptionInCart &&
    !isLuxPlusPricingShownToEveryone

  if (isPreviewMemberBlocked) {
    return false
  }

  return getCanViewLuxPlusBenefits(state) ||
    (getIsFreePreviewLuxPlusMember(state) && getIsEnabledFlightsLuxPlusPreview(state)) ||
    (!!isBundledFlow && subscriptionInCart) ||
    getIsFlightsLuxPlusPricingEligibleSpoofedNonMember(state) ||
    isLuxPlusPricingShownToEveryone
}
